const AdditionalCommentsOverview = ({ data }) => {
  if (!data) return null;
  const data1 = data["8_0"];
  const { additional_comment } = data1;
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            If there is any detail that was not covered in the sections above,
            please mention it here in this section.
          </div>
          <div className="overview-val-text">
            {additional_comment?.length ? additional_comment : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdditionalCommentsOverview;
